"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOUR_COPY = exports.TOUR_STEP_COPY = exports.PLAID_PHONE_COPY = exports.TOUR_ENTRY_POINTS = exports.CLOSED_TOUR = exports.TOUR_LENGTH = void 0;
exports.tourReducer = tourReducer;
exports.tourTransition = tourTransition;
/**
 * The setup tour's state machine and copy, shared by web and mobile (BEN-141).
 *
 * A walk through the five steps of setup that DESCRIBES them and does nothing
 * else. Rules, pinned by the web and mobile tests:
 *  1. No slide is a link and no control starts an action.
 *  2. However it closes, the wizard stays on the step the tour was opened from.
 *     (It said Welcome until FP-079, 2026-10-06: no product reason was recorded,
 *     iOS already stayed put, and moving the user back to the start of a flow
 *     they were partway through was the cost. Both clients now stay.)
 *  3. It is offered only before a bank is connected (Welcome and Connect bank).
 *
 * What each platform adds on top: web gives the tour a browser-history entry so
 * Back closes it (frontend/src/lib/setupTour.ts, tourHistoryEffect); mobile closes
 * it from the modal's onRequestClose, which is Android's hardware back and the
 * iOS sheet swipe. Both arrive here as the "browser-back" action -- the platform's
 * own back gesture -- which is an exit like any other.
 */
const welcomeSteps_1 = require("./welcomeSteps");
exports.TOUR_LENGTH = welcomeSteps_1.WELCOME_STEPS.length;
exports.CLOSED_TOUR = { open: false, index: 0 };
function tourReducer(state, action) {
    switch (action.type) {
        case "open":
            return { open: true, index: 0 };
        case "next":
            // Next on the last slide finishes the tour; it never continues into setup.
            return state.index >= exports.TOUR_LENGTH - 1
                ? exports.CLOSED_TOUR
                : { ...state, index: state.index + 1 };
        case "back":
            return { ...state, index: Math.max(0, state.index - 1) };
        case "exit":
        case "browser-back":
            return exports.CLOSED_TOUR;
    }
}
/** The steps the tour may be opened from (rule 3). */
exports.TOUR_ENTRY_POINTS = ["welcome", "connect-bank"];
/**
 * One tour action applied to the tour and the setup step it sits over. Nothing
 * the tour does moves the wizard: not opening it, not moving through it (rule 1),
 * and not closing it by any route (rule 2).
 */
function tourTransition(state, action) {
    return { tour: tourReducer(state.tour, action), step: state.step };
}
/** Plaid's two optional phone prompts, and the button that skips each. */
exports.PLAID_PHONE_COPY = "Plaid may ask for your phone number twice, and both are optional. Before you pick your bank, choose “Continue without phone number”. After you sign in to your bank, choose “Finish without saving”.";
/** Extra copy for a slide, beyond the step's own title and description. Keyed
 *  `detail` so scripts/copy-inventory.mjs lists it for review with the rest. */
exports.TOUR_STEP_COPY = {
    // What Anthony actually hit. Plaid asks for a phone number twice: on its first
    // pane, to recognise returning users, and again after the bank login ("Connect
    // faster next time", 21-plaid-after-submit-1.png, 2026-09-25). We send Plaid no
    // phone field and Clerk has phone disabled, so these are the only phone prompts
    // in the whole flow. Shared with the Connect bank step as PLAID_PHONE_COPY.
    "connect-accounts": {
        detail: `Your bank connection is handled by Plaid. ${exports.PLAID_PHONE_COPY}`,
    },
};
/** The tour dialog's own chrome, shared so the two platforms say the same thing. */
exports.TOUR_COPY = {
    title: "Tour of setup",
    description: "What each step does. Nothing here starts setup or connects anything.",
    exit: "Exit tour and go back to setup",
    finish: "Finish tour",
};
//# sourceMappingURL=setupTour.js.map